import PropTypes from 'prop-types';

export const CspConfigurationPropTypes = PropTypes.shape({
  IsPayNowEnabled: PropTypes.bool,
  IsLegacyPaymentEnabled: PropTypes.bool,
  IsNotificationPreferencesEnabled: PropTypes.bool,
  IsKontentAIPreviewEnabled: PropTypes.bool,
  IsLiteModeEnabled: PropTypes.bool,
  IsLiveVetEnabled: PropTypes.bool,
  IsExcessEnabled: PropTypes.bool,
  IsWhatsCoveredEnabled: PropTypes.bool,
  IsLEC: PropTypes.bool,
  IsShortBirthdate: PropTypes.bool,
  IsDualPortal: PropTypes.bool,
  IsInstalmentProcessingEnabled: PropTypes.bool,
  IsV3PenTestRemediationEndpointsEnabled: PropTypes.bool,
  IsFallbackModeMiddlewareApiEnabled: PropTypes.bool
});
